import React, { Fragment, Component } from "react";
import "./Slider.css";
import * as math from "mathjs";
import ExceptionReturn from "./../Tabs/ExceptionReturn/ExceptionReturn";

class Slider extends Component {
  constructor(props) {
    super(props);
    this.handleReset = this.handleReset.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleKey = this.handleKey.bind(this);
    this.handleDisable = this.handleDisable.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.state = {
      isEdge:
        !(/*@cc_on!@*/ (false || !!document.documentMode)) &&
        !!window.StyleMedia,
      value: this.props.value,
      inRangeMin: this.props.inRangeMin,
      inRangeMax: this.props.inRangeMax,
      ptsEarned: this.props.ptsEarned,
      disableFlag: this.props.disableFlag,
      projectedChange: 0.0,
      agiflag: this.props.metric.includes("AGI") ? 1 : 0,
      wideAGIRangeFlag:
        this.props.metric.includes("AGI") &&
        (this.props.originalValue > 10 || this.props.originalValue < -10)
    };
  }
  componentDidMount() {
    let pChange = 0.0;

    if (this.state.agiflag) {
      if (this.state.value > this.props.inRangeMax) {
        pChange = this.props.ptsPossible;
      } else if (
        this.state.value >= this.props.inRangeMin &&
        this.state.value <= this.props.inRangeMax &&
        this.state.value !== this.props.originalValue
      ) {
        pChange = math.round(
          (math.abs(this.state.value - this.props.inRangeMin) /
            (math.abs(this.props.inRangeMax) +
              math.abs(this.props.inRangeMin))) *
            this.props.ptsPossible +
            (this.props.value > this.props.inRangeMin
              ? 0
              : -this.props.ptsEarned),
          3
        );
      } else if (this.state.value < this.props.inRangeMin) {
        pChange = this.props.ptsEarned * -1;
      }
    } else {
      if (this.state.value <= this.props.inRangeMin) {
        pChange = this.props.ptsEarned * -1;
      }
      if (
        this.state.value > this.props.inRangeMin &&
        this.state.value <= this.props.inRangeMax &&
        this.state.value !== this.props.originalValue
      ) {
        pChange = math.round(
          ((this.state.value - this.props.inRangeMin) /
            (this.props.inRangeMax - this.props.inRangeMin)) *
            this.props.ptsPossible,
          3
        );
      }
      if (this.state.value > this.props.inRangeMax) {
        pChange = this.props.ptsPossible;
      }
    }
    pChange =
      pChange !== 0 && !this.state.disableFlag
        ? math.round(pChange - this.props.ptsEarned, 3)
        : pChange;

    if (pChange < this.props.ptsEarned * -1)
      pChange = this.props.ptsEarned * -1;

    this.setState({
      projectedChange: pChange
    });
  }

  handleReset(e) {
    e.preventDefault();
    this.props.handler(
      this.props.domain,
      this.props.metric,
      0,
      this.props.originalValue,
      0,
      0
    );
    this.props.handlerDisable(
      this.props.domain,
      this.props.metric,
      this.props.hardDisableFlag
    );
  }
  handleKey(e) {
    let pChange = 0.0;

    if (e.target.value < this.props.inRangeMin) {
      pChange = -this.props.ptsEarned;
    }
    if (
      e.target.value >= this.props.inRangeMin &&
      e.target.value <= this.props.inRangeMax
    ) {
      pChange = math.round(
        ((e.target.value - this.props.inRangeMin) /
          (this.props.inRangeMax - this.props.inRangeMin)) *
          this.props.ptsPossible -
          this.props.ptsEarned,
        3
      );
    }
    if (e.target.value > this.props.inRangeMax) {
      pChange = this.props.ptsPossible - this.props.ptsEarned;
    }
    let newValue =
      this.props.metric.includes("AGI") && this.state.wideAGIRangeFlag
        ? e.target.value > 20
          ? 20
          : e.target.value < -20
          ? -20
          : e.target.value
        : this.props.metric.includes("AGI") && !this.state.wideAGIRangeFlag
        ? e.target.value > 10
          ? 10
          : e.target.value < -10
          ? -10
          : e.target.value
        : e.target.value > 100
        ? 100
        : e.target.value < 0
        ? 0
        : e.target.value;

    if (e.key === "Enter") {
      this.props.handler(
        this.props.domain,
        this.props.metric,
        pChange, // Not changing
        newValue,
        math.round(pChange - this.props.ptsEarned, 3), //Not changing
        0
      );
    }
  }
  handleMouseUp(e) {
    let pChange = 0.0;
    if (this.state.agiflag) {
      if (this.state.value > this.props.inRangeMax) {
        pChange = this.props.ptsPossible - this.props.ptsEarned;
      } else if (
        this.state.value > this.props.inRangeMin &&
        this.state.value <= this.props.inRangeMax &&
        this.state.value !== this.props.originalValue
      ) {
        pChange = math.round(
          (math.abs(this.state.value - this.props.inRangeMin) /
            (math.abs(this.props.inRangeMax) +
              math.abs(this.props.inRangeMin))) *
            this.props.ptsPossible -
            this.props.ptsEarned,
          3
        );
      } else if (this.state.value < this.props.inRangeMin) {
        pChange = -this.props.ptsEarned;
      }
    } else {
      if (this.state.value <= this.props.inRangeMin) {
        pChange = this.props.ptsEarned * -1;
      }
      if (
        this.state.value > this.props.inRangeMin &&
        this.state.value <= this.props.inRangeMax &&
        this.state.value !== this.props.originalValue
      ) {
        pChange = math.round(
          ((this.state.value - this.props.inRangeMin) /
            (this.props.inRangeMax - this.props.inRangeMin)) *
            this.props.ptsPossible -
            this.props.ptsEarned,
          3
        );
      }
      if (this.state.value > this.props.inRangeMax) {
        pChange = this.props.ptsPossible - this.props.ptsEarned;
      }
    }
    let newValue =
      this.state.agiflag && this.state.wideAGIRangeFlag
        ? e.target.value > 20
          ? 20
          : e.target.value < -20
          ? -20
          : e.target.value
        : this.state.agiflag && !this.state.wideAGIRangeFlag
        ? e.target.value > 10
          ? 10
          : e.target.value < -10
          ? -10
          : e.target.value
        : e.target.value > 100
        ? 100
        : e.target.value < 0
        ? 0
        : e.target.value;
    this.props.handler(
      this.props.domain,
      this.props.metric,
      pChange,
      newValue,
      math.round(pChange - this.props.ptsEarned, 3),
      this.props.hardDisableFlag ? this.props.ptsPossible : 0
    );
  }

  handleChange(e) {
    let pChange = this.state.ptsEarned;

    if (this.state.agiflag) {
      if (this.state.value > this.props.inRangeMax) {
        pChange = this.props.ptsPossible /*  - this.props.ptsEarned */;
      } else if (
        this.state.value > this.props.inRangeMin &&
        this.state.value <= this.props.inRangeMax &&
        this.state.value !== this.props.originalValue
      ) {
        pChange = math.round(
          (math.abs(this.state.value - this.props.inRangeMin) /
            (math.abs(this.props.inRangeMax) +
              math.abs(this.props.inRangeMin))) *
            this.props.ptsPossible,
          3
        ) /*  - this.props.ptsEarned */;
      } else if (this.state.value < this.props.inRangeMin) {
        pChange = 0;
      }
    } else {
      if (this.state.value <= this.props.inRangeMin) {
        pChange = 0;
      }
      if (
        this.state.value > this.props.inRangeMin &&
        this.state.value <= this.props.inRangeMax &&
        this.state.value !== this.props.originalValue
      ) {
        pChange = math.round(
          ((this.state.value - this.props.inRangeMin) /
            (this.props.inRangeMax - this.props.inRangeMin)) *
            this.props.ptsPossible,
          3
        );
      }
      if (this.state.value > this.props.inRangeMax) {
        pChange = this.props.ptsPossible;
      }
    }
    this.setState({
      value: e.target.value,
      projectedChange: math.round(pChange - this.props.ptsEarned, 3)
    });
  }
  handleDisable() {
    this.props.handlerDisable(
      this.props.domain,
      this.props.metric,
      !this.props.disableFlag
    );
  }
  classColorChange() {
    const colorValue = this.state.projectedChange;
    let newClass = "black";
    colorValue > 0
      ? (newClass = "projected-container positivePoints")
      : colorValue < 0
      ? (newClass = "projected-container negativePoints")
      : (newClass = "projected-container black");
    return newClass;
  }
  classSymbol() {
    const symbolValue = this.state.projectedChange;
    let newSymbol = "";
    if (symbolValue > 0) {
      newSymbol = "+";
    } else if (symbolValue < 0) {
      newSymbol = "";
    } else {
      newSymbol = "";
    }
    return newSymbol;
  }
  rangeMin() {
    if (this.props.metric.includes("AGI")) {
      this.state.agiflag = 1;
      return "-10";
    } else {
      this.state.agiflag = 0;
      return "0";
    }
  }
  rangeMax() {
    let a;
    if (this.props.metric.includes("AGI")) {
      return "10";
    } else {
      return "100";
    }
  }

  render() {
    const origValue = this.props.originalValue;
    const agiFlag = this.state.agiflag;
    return (
      <Fragment>
        <td className="column_slider">
          <p>
            {this.props.metric}
            <span
              className={
                this.state.disableFlag ? "disableButton" : "enableButton"
              }
              onClick={this.handleDisable}
            >
              {this.state.disableFlag ? "Click to Add" : "Click to Remove"}
            </span>
          </p>
          {this.state.disableFlag ? (
            <div className="disabledMetric">
              <ExceptionReturn
                disable={this.props.hardDisableFlag}
                key={Math.random()}
                metricTitle={this.props.metric}
                exceptionNumber={Number(this.props.exceptionNumber)}
              />
            </div>
          ) : (
            <div className="slider-container">
              <small className={agiFlag ? "rangeNum leftAGI" : "rangeNum left"}>
                {this.state.wideAGIRangeFlag ? "-20" : this.rangeMin()}
              </small>
              <div className="range" />
              <small className="rangeNum right">
                {this.state.wideAGIRangeFlag ? "20" : this.rangeMax()}
              </small>
              <div
                className="vbar rangea"
                style={
                  this.state.wideAGIRangeFlag
                    ? { left: 52 + this.state.inRangeMin * 2.5 + "%" }
                    : agiFlag
                    ? { left: 50.5 + this.state.inRangeMin * 4 + "%" }
                    : { left: this.state.inRangeMin + "%" }
                }
                title={this.state.inRangeMin}
              />
              <div className="sliderDiv">
                <input
                  className="slider"
                  domain={this.props.domain}
                  metric={this.props.metric}
                  type="range"
                  min={this.state.wideAGIRangeFlag ? "-20" : this.rangeMin()}
                  max={this.state.wideAGIRangeFlag ? "20" : this.rangeMax()}
                  step={this.props.metric.includes("AGI") ? "0.01" : "0.1"}
                  value={
                    this.state.isEdge
                      ? this.props.metric.includes("AGI")
                        ? math.round(this.state.value, 3)
                        : math.round(this.state.value, 3)
                      : this.props.metric.includes("AGI")
                      ? math.round(this.state.value, 3).toFixed(2)
                      : math.round(this.state.value, 3).toFixed(1)
                  }
                  onChange={event => this.handleChange(event)}
                  onMouseUp={this.handleMouseUp}
                  onClick={event => this.handleChange(event)}
                />
              </div>
              <div
                className="rangeBar"
                style={
                  this.state.wideAGIRangeFlag
                    ? {
                        width:
                          2 *
                            (math.abs(this.state.inRangeMax) +
                              math.abs(this.state.inRangeMin)) +
                          1 +
                          "%",
                        left: 51 + this.state.inRangeMin + "%"
                      }
                    : agiFlag
                    ? {
                        width:
                          4 *
                            (math.abs(this.state.inRangeMax) +
                              math.abs(this.state.inRangeMin)) +
                          3 +
                          "%",
                        left: 48 + this.state.inRangeMin + "%"
                      }
                    : {
                        width:
                          this.state.inRangeMax - this.state.inRangeMin + "%",
                        left: this.state.inRangeMin + "%"
                      }
                }
              />
              <div
                className="vbar rangeb"
                style={
                  this.state.wideAGIRangeFlag
                    ? { left: 52 + this.state.inRangeMax * 2.5 + "%" }
                    : agiFlag
                    ? { left: 54 + this.state.inRangeMax * 4 + "%" }
                    : { left: this.state.inRangeMax + "%" }
                }
                title={this.state.inRangeMax}
              />
              <div
                className="vbar score"
                style={{
                  left: this.state.wideAGIRangeFlag
                    ? 50 + origValue * 2.5 + "%"
                    : agiFlag
                    ? 50 + origValue * 5 + "%"
                    : origValue + "%",
                  display: this.props.hardDisableFlag ? "none" : ""
                }}
              />

              <small
                className="originalScore"
                style={{
                  left: this.state.wideAGIRangeFlag
                    ? this.state.isEdge
                      ? 48 + math.round(origValue, 2) * 2.5 + "%"
                      : 48 + math.round(origValue, 2).toFixed(2) * 2.5 + "%"
                    : agiFlag
                    ? !this.state.isEdge
                      ? 50 + math.round(origValue, 2).toFixed(2) * 5 + "%"
                      : 50 + math.round(origValue, 2) * 5 + "%"
                    : !this.state.isEdge
                    ? math.round(origValue, 1).toFixed(1) - 2.5 + "%"
                    : math.round(origValue, 1) - 2.5 + "%",
                  display: this.props.hardDisableFlag ? "none" : ""
                }}
              >
                {this.state.isEdge
                  ? agiFlag
                    ? math.round(origValue, 2)
                    : math.round(origValue, 1)
                  : agiFlag
                  ? math.round(origValue, 2).toFixed(2)
                  : math.round(origValue, 1).toFixed(1)}
              </small>
              <input
                className="sliderText"
                defaultValue={
                  this.state.isEdge
                    ? this.props.metric.includes("AGI")
                      ? math.round(this.state.value, 2)
                      : math.round(this.state.value, 1)
                    : this.props.metric.includes("AGI")
                    ? math.round(this.state.value, 2).toFixed(2)
                    : math.round(this.state.value, 1).toFixed(1)
                }
                style={
                  this.state.wideAGIRangeFlag
                    ? { marginLeft: this.state.value * 2.5 + 48 + "%" }
                    : agiFlag
                    ? {
                        marginLeft: this.state.value * 5 + 50 + "%"
                      }
                    : { marginLeft: this.state.value - 3 + "%" }
                }
                onKeyPress={this.handleKey}
                step="0.01"
              />
            </div>
          )}
        </td>
        <td className="column_points">
          <div className="current-points">
            <div className="halfsize">
              {this.props.hardDisableFlag
                ? "--"
                : this.props.ptsEarned.toFixed(2)}
              <br />
              out of
              <br />
              {this.props.hardPtsPossible.toFixed(2)}
            </div>
            <div className="halfsize">
              {this.props.hardDisableFlag ? "--" : this.props.pctEarned + "%"}
            </div>
          </div>
        </td>
        <td className="column_points ">
          <div className="projected-points ">
            <div className="halfsize">
              {this.state.disableFlag
                ? "--"
                : math
                    .round(this.props.ptsEarned + this.state.projectedChange, 2)
                    .toFixed(2)}
              <br />
              out of
              <br />
              {this.state.disableFlag
                ? "--"
                : this.props.ptsPossible.toFixed(2)}
            </div>
            <div className="halfsize">
              {this.state.disableFlag
                ? "--"
                : this.props.ptsPossible === 0
                ? 0
                : (
                    math.round(
                      (this.props.ptsEarned + this.state.projectedChange) /
                        this.props.ptsPossible,
                      2
                    ) * 100
                  ).toFixed(0) + "%"}
            </div>
          </div>
        </td>
        <td className="column_change">
          <div className={this.classColorChange()}>
            <span>
              <span>{this.classSymbol()}</span>
              {this.state.projectedChange.toFixed(2)}
            </span>
          </div>
        </td>
        <td className="column_reset">
          <div className="reset-container">
            <div className="resetButton" onClick={this.handleReset}>
              {" "}
              RESET{" "}
            </div>
          </div>
        </td>
        {/* </div> */}
      </Fragment>
    );
  }
}

export default Slider;
